import { createEntityStore, type EntityState } from '@datorama/akita';
import {
   type OrganisationAssignment,
   type TaxonomyActivity,
   type TaxonomyBusinessActivity,
   type TaxonomyCriterion,
   type TaxonomyCriterionResponse,
} from 'types/models';
export interface TaxonomyBusinessActivitiesState extends EntityState<TaxonomyBusinessActivity> {
   activeCriterion?: TaxonomyCriterion['id'];
   activeOrganisationAssignment?: OrganisationAssignment['id'];
   statistics: any;
   filter: string;
   searchTerm: string;
   assignedTaxonomyActivities: TaxonomyActivity[];
   unassignedBusinessActivities: TaxonomyBusinessActivity[];
   businessActivitiesInScope: TaxonomyBusinessActivity[];
   businessActivitiesOutOfScope: TaxonomyBusinessActivity[];
}

export type TaxonomyResponsesState = EntityState<TaxonomyCriterionResponse>;

export const businessActivitiesStore = createEntityStore<TaxonomyBusinessActivitiesState>(
   {
      activeCriterion: undefined,
      activeOrganisationAssignment: undefined,
      statistics: undefined,
      filter: 'ALL',
      searchTerm: undefined,
      assignedTaxonomyActivities: [],
      unassignedBusinessActivities: [],
      businessActivitiesInScope: [],
      businessActivitiesOutOfScope: [],
   },
   { resettable: true, name: 'taxonomy/businessactivities' }
);

export const responsesStore = createEntityStore<TaxonomyResponsesState>({}, { resettable: true, name: 'taxonomy/responses' });
